import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerServiceWorker } from './utils/serviceWorker';
import { ascoltaInstallazione } from './utils/installa';

// Registra Service Worker per PWA
registerServiceWorker();

// «Installate l'app»: Chrome offre l'installazione con un evento che lancia una volta sola e prestissimo, spesso
// prima che React sia in piedi. Si intercetta qui e si conserva, per aprire la finestra vera quando il cliente
// tocca «Installa» (utils/installa.js).
ascoltaInstallazione();

// Sopprime l'errore ResizeObserver (bug noto Radix UI/Shadcn Select)
// Questo errore NON impatta la funzionalità - è solo un warning del browser
const RESIZE_ERR = 'ResizeObserver loop';

// Sovrascrive il ResizeObserver per evitare che lanci errori
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Esegue il callback in requestAnimationFrame per evitare il loop error
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Cattura errori a livello window
window.addEventListener('error', (e) => {
  if (e.message?.includes(RESIZE_ERR)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return true;
  }
});

// Cattura anche unhandledrejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes(RESIZE_ERR)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
